<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
    <div class="title-container">
      <h5>{{ isEditMode ? 'Edit' : 'Create' }} Promotion</h5>
      <a *ngIf="isEditMode" (click)="onCreateNew()" class="create-new">Create New</a>
    </div>

    <div class="promotion-type-selection" disabled>
      <div class="promotion-option" [class.active]="promotionOption === 'free-spin'" (click)="!isEditMode ? onSelectPromotionOption('free-spin') : null">
        <p>Free Spin</p>
      </div>
       <!-- 
      <div class="promotion-option" disabled>
        <p>Free Credit</p>
      </div> -->
      <div class="promotion-option" [class.active]="promotionOption === 'provider-promotion'" (click)="!isEditMode ? onSelectPromotionOption('provider-promotion') : null">
        <p>Provider Promotion</p>
      </div>
    </div>

    <div class="promotion-stepper">
      <ng-container *ngIf="loading">
        <div class="spinner-wrapper">
          <mat-progress-spinner mode="indeterminate" class="spinner" diameter="20"></mat-progress-spinner>
        </div>
      </ng-container>
      <div class="row m-0">
        <div class="sidebar-column p-0">
          <!-- Sidebar -->
          <div class="sidebar">
            <ul>
              <li *ngFor="let step of steps; let i = index" [class.active]="i === currentStepIndex" (click)="onToTab(i)">
                <span [ngClass]="getStepDotClass(step.label)">
                    <i *ngIf="getStepDotClass(step.label) === 'passed-dot'" class="fas fa-check"></i>
                    <i *ngIf="getStepDotClass(step.label) === 'red-dot'" class="fa fa-times"></i>
                </span>
                {{ displayStepLabel(step.label) }}
              </li>
            </ul>
          </div>
        </div>

        <div class="content-column p-0">
          <!-- Content -->
          <div class="content">
            <!-- Wraps the step only (not the Back/Next actions): the first real interaction here
                 stops this step's dirty-check baseline from re-capturing, so async patches that
                 land while the step is still loading aren't mistaken for operator edits. -->
            <div (click)="onStepInteraction()" (input)="onStepInteraction()" (change)="onStepInteraction()" (keydown)="onStepInteraction()">
              <ng-container *ngIf="steps[currentStepIndex]">
                <ng-container
                  *ngComponentOutlet="
                    steps[currentStepIndex].component;
                    injector: stepInjectors[currentStepIndex]
                  ">
                </ng-container>
              </ng-container>
            </div>

            <div class="actions">
              <button class="promo-back-button" mat-button (click)="onBack()" [disabled]="currentStepIndex === 0">
                <i class="fas fa-arrow-left"></i>Back
              </button>
              <button class="promo-next-button" mat-button (click)="onSaveBlacklistPreset()" *ngIf="steps[currentStepIndex]?.label === 'Provider Blacklist'"
                [disabled]="loading || submitting"
                style="width:auto; min-width:150px; padding:0 20px; white-space:nowrap; margin-left:auto; margin-right:12px;">
                Save as Preset
              </button>
              <button class="promo-next-button" mat-button (click)="onNext()" *ngIf="currentStepIndex !== steps.length - 1" [disabled]="loading || submitting"
                style="margin-left:auto; margin-right:12px;">
                Next
              </button>
              <!-- Edit mode shows Update on every step: the record already exists and formData holds the
                   whole promotion (seeded from showV4), so steps the operator never opened submit their
                   loaded values unchanged. Create still submits only from the last step, where every
                   step has been filled in. -->
              <button class="promo-next-button" mat-button (click)="onSubmit()" *ngIf="isEditMode ? canEditPromotionCode : currentStepIndex === steps.length - 1"
                [disabled]="findInvalidControls() || submitting || loading || (isEditMode && !hasUnsavedChanges)">
                {{ submitting ? 'Saving...' : (isEditMode ? 'Update' : 'Submit') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onReload($event)"></kt-swal-alert>